import styled from 'styled-components';

export const SalesNewSettingsContainer = styled.div`
  padding: 20px;
`;

export const MainWrapper = styled.div`
  background-color: white;
  border-radius: 24px;
  box-shadow:
    0px 4px 6px -4px #0000001a,
    0px 10px 15px -3px #0000001a;
  padding: 24px;
`;

export const SalesNewSettingsTabs = styled.div`
  display: flex;
  flex-wrap: nowrap;
  border-radius: 16px;
  background: linear-gradient(
    90deg,
    rgba(219, 234, 254, 0.5) 0%,
    rgba(243, 232, 255, 0.5) 100%
  );
  width: max-content;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px;
  gap: 8px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
    transition: background 0.2s ease;
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background: rgba(108, 117, 125, 0.6);
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(108, 117, 125, 0.8);
    }
  }

  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  &:hover {
    scrollbar-color: rgba(108, 117, 125, 0.6) transparent;
  }
`;

export const TabButton = styled.button`
  position: relative;
  width: 135px;
  height: 30px;
  background-color: ${({ $active }) => ($active ? '#ffffff' : 'transparent')};
  padding: 0;
  border: none;
  border-radius: 14px;
  color: #000000;
  font-family: 'Nunito', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  white-space: nowrap;
  box-shadow: ${({ $active }) =>
    $active
      ? '0px 2px 4px -2px rgba(0, 0, 0, 0.1), 0px 4px 6px -1px rgba(0, 0, 0, 0.1)'
      : 'none'};

  &:hover {
    opacity: 0.9;
  }
`;

export const TabContent = styled.div`
  font-size: 24px;
  margin-top: 20px;
`;
